import styled from '@emotion/styled'
import { CSSProperties, ReactNode } from 'react'
import { typography, TypographyProps as StyledTypographyProps } from 'styled-system'
import { ClassName } from 'types/props'

export const variantComponentMap = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  sh1: 'h6',
  sh2: 'h6',
  sh3: 'h6',
  sh4: 'h6',
  sh5: 'h6',
  b1: 'p',
  b2: 'p',
  b3: 'p',
  b4: 'p',
  b5: 'p',
  link: 'a',
  i1: 'p'
}
export type Color = 'primary' | 'secondary' | 'tertiary' | 'white' | 'black' | 'grey' | 'error'
export type Variant = keyof typeof variantComponentMap
export type FontStyle = CSSProperties['fontStyle']

const sizes = {
  h1: { fontSize: 56, lineHeight: 'normal', letterSpacing: 0.4, fontWeight: 800 },
  h2: { fontSize: 38, lineHeight: 'normal', letterSpacing: 0.7, fontWeight: 800 },
  h3: { fontSize: 26, lineHeight: 'normal', letterSpacing: 0.4, fontWeight: 800 },
  h4: { fontSize: 22, lineHeight: '28px', letterSpacing: 0.3, fontWeight: 800 },
  h5: { fontSize: 18, lineHeight: '28px', letterSpacing: 0.3, fontWeight: 800 },
  sh1: { fontSize: 17, letterSpacing: 0.3, fontWeight: 600 },
  sh2: { fontSize: 15, letterSpacing: 0.2, fontWeight: 600 },
  sh3: { fontSize: 13, letterSpacing: 0.2, fontWeight: 600 },
  sh4: { fontSize: 11, letterSpacing: 0.2, fontWeight: 600 },
  sh5: { fontSize: 9, letterSpacing: 0.2, fontWeight: 600 },
  b1: { fontSize: 17, lineHeight: 'normal', letterSpacing: 0.5, fontWeight: 'normal' },
  b2: { fontSize: 15, lineHeight: 'normal', letterSpacing: 0.3, fontWeight: 'normal' },
  b3: { fontSize: 13, lineHeight: 'normal', letterSpacing: 0.3, fontWeight: 'normal' },
  b4: { fontSize: 11, lineHeight: 'normal', letterSpacing: 0.3, fontWeight: 'normal' },
  b5: { fontSize: 9, lineHeight: 'normal', letterSpacing: 0.3, fontWeight: 'normal' },
  i1: { fontSize: 12, lineHeight: 'normal', letterSpacing: 0.09, fontWeight: 'normal' }
}

const colorMap = {
  white20: 'var(--White20)',
  white40: 'var(--White40)',
  white60: 'var(--White60)'
}

const StyledTypography = styled.div<StyledTypographyProps>`
  ${typography}
  color: ${props => colorMap[props.color]};
`

export interface TypographyProps extends StyledTypographyProps, ClassName {
  children: ReactNode
  color?: keyof typeof colorMap
  variant: Variant
}

const Typography = ({ className, color = 'white20', variant, ...props }: TypographyProps) => {
  const sizeProps = sizes[variant]

  return <StyledTypography className={className} color={color} {...sizeProps} {...props} />
}

export default Typography
